<template>
  <md-card class="md-card-profile">
    <md-card-content>
      <h4 class="card-title">Aktivität</h4>
      <div>
        <form>
          <md-card v-if="user">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Titel</label>
                    <md-input v-model="activity.title" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label for="activityType">activityType</label>
                    <md-select
                      v-model="activity.activityType"
                      name="activityType"
                      id="activityType"
                    >
                      <md-option value="1">laufen</md-option>
                      <md-option value="2">gehen</md-option>
                      <md-option value="3">radfahren</md-option>
                      <md-option value="4">schwimmen</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label for="externalDataSourceId">activityType</label>
                    <md-select
                      v-model="activity.externalDataSourceId"
                      name="externalDataSourceId"
                      id="externalDataSourceId"
                    >
                      <md-option value="2">Garmin</md-option>
                      <md-option value="3">Polar</md-option>
                      <md-option value="11">Strava</md-option>
                      <md-option value="15">Runtastic</md-option>
                      <md-option value="17">Suunto</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Start</label>
                    <md-input v-model="activity.start" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-50">
                  <md-field>
                    <label>Distanz</label>
                    <md-input
                      v-model="activity.data.distanceInMeters"
                      type="number"
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-size-50">
                  <md-field>
                    <label
                      >Sekunden ({{
                        formatTime(activity.durationInSeconds)
                      }})</label
                    >
                    <md-input
                      v-model="activity.durationInSeconds"
                      type="number"
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-right">
                  <md-button class="md-raised md-success mt-4" @click="update"
                    >Bestätigen</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
      <md-button class="md-round" @click="fetchActivities()"
        >fetch activities</md-button
      >
    </md-card-content>
    <md-card-actions>
      <md-button class="md-raised md-success mt-4" @click="testMsg(false)"
        >new</md-button
      >
      <md-button class="md-raised md-success mt-4" @click="testMsg(true)"
        >push</md-button
      >
    </md-card-actions>
  </md-card>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "admin",
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  data() {
    return {
      activity: {
        activityType: 1,
        externalDataSourceId: 11,
        start: "2020-09-05T10:58:24.000Z", //ISODate("2020-06-03T04:58:24.000Z"),
        // userId: ObjectId("5ee1fb94656baa5d199b87f1"),
        data: {
          distanceInMeters: 5000
        },
        durationInSeconds: 1971,
        private: false,
        title: "Titel",
        manual: false
      }
    };
  },
  methods: {
    testMsg(push) {
      this.$store.dispatch("testNotification", { push: push }).then(() => {
        console.log("User loaded");
      });
    },
    update() {
      let activity = this.activity;
      console.log(activity);
      this.$store.dispatch("createActivity", activity).then(res => {
        this.$notify({
          timeout: 5000,
          message: "Aktivitäten wurde angelegt!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
      });
      console.log("update");
    },
    formatTime(value) {
      if (value == null) {
        return null;
      }
      let seconds = value % 60;
      value = Math.floor(value / 60);
      let minutes = value % 60;
      value = Math.floor(value / 60);
      let hours = value;
      let pad = i => ("0" + i).substr(-2);
      return (hours > 0 ? hours + ":" : "") + pad(minutes) + ":" + pad(seconds);
    },
    fetchActivities() {
      if (this.$store.state.isAdmin) {
        this.$store
        .dispatch("queryAPI", {url: "/rest/activity/fetchMyActivities"})
        .then(() => {
          this.$notify({
            timeout: 5000,
            message: "Aktivitäten wurden aktualisiert!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        });
      }
    }
  },
  mounted() {
    let activity = { title: "TEST" };
  }
};
</script>
<style></style>
